import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/Industries/Fintech.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/JsonLd.tsx");
